/**
 * LA BANDIERINA DI UNA LINGUA, accanto alla sigla nella tendina (chiesta
 * l'8/10). Una lingua non e' un paese: qui c'e' il paese che la rappresenta
 * meglio per chi guarda, e se la skin un giorno manda `paese` accanto alla
 * lingua (Sito › Skin › Parole) vince quello. Senza voce qui si prova la
 * sigla stessa come codice paese (it → it, de → de), e Bandiera decide se
 * c'e' un disegno o l'emoji. Il portoghese e' quello del Brasile (chiesto il
 * 23/10), quindi la sua bandierina e' brasiliana.
 */
const PAESE = {
  en: 'gb', es: 'es', pt: 'br', fr: 'fr', it: 'it', de: 'de', tr: 'tr', ru: 'ru', ar: 'sa',
  zh: 'cn', ja: 'jp', ko: 'kr', hi: 'in', el: 'gr', sq: 'al', sr: 'rs', uk: 'ua', cs: 'cz',
  da: 'dk', sv: 'se', nb: 'no', no: 'no', fi: 'fi', vi: 'vn', th: 'th', id: 'id', ms: 'my',
  he: 'il', fa: 'ir', ur: 'pk', bn: 'bd', sw: 'ke', nl: 'nl', pl: 'pl', ro: 'ro', hu: 'hu', bg: 'bg', hr: 'hr',
};
export function paeseDellaLingua(codice, paese) {
  if (paese) return String(paese).toLowerCase();
  const c = String(codice || '').toLowerCase().slice(0, 2);
  return PAESE[c] || c;
}
